import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

const MinusIcon = (props: SvgIconProps) => (
  <SvgIcon width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path d="M19 11.5a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2h14z" fillRule="nonzero" />
  </SvgIcon>
);

export default MinusIcon;
